import React from "react";

export function FundraiserContent({ html }) {
  if (!html) {
    return null;
  }

  return (
    <section className="bg-white text-gray-800 px-5 md:px-15 lg:px-23 py-11">
      <div className="max-w-4xl mx-auto">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </section>
  );
}
